import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../components/layout/SidebarPageLayout';

function Messaging() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub - Messaging";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="p-5">
        <h1>Messaging</h1>
      </div>
    </SidebarPageLayout>
  );
}

export default Messaging;
